import { Route, Routes } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './pages/Home'
import Standings from './pages/Standings'
import Stats from './pages/Stats'
import HallOfChampions from './pages/HallOfChampions'
import Historical from './pages/Historical'
import NerdData from './pages/NerdData'
import GamesList from './pages/GamesList'
import InGamePlayerLog from './pages/InGamePlayerLog'
import MySchedule from './pages/MySchedule'
import GameDetails from './pages/GameDetails'
import PlayerProfile from './pages/PlayerProfile'
import Playoffs from './pages/Playoffs'
import Upload from './pages/Upload'
import Account from './pages/Account'
import Admin from './pages/Admin'
import Rules from './pages/Rules'
import Updates from './pages/Updates'
import Changelog from './pages/Changelog'
import NotFound from './pages/NotFound'

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="standings" element={<Standings />} />
        <Route path="stats" element={<Stats />} />
        <Route path="hall-of-champions" element={<HallOfChampions />} />
        {/* Bare path lands on the newest bracket; see Playoffs. */}
        <Route path="playoffs" element={<Playoffs />} />
        <Route path="playoffs/:seasonNumber" element={<Playoffs />} />
        <Route path="historical" element={<Historical />} />
        <Route path="historical/:seasonNumber" element={<Historical />} />
        <Route path="nerd-data" element={<NerdData />} />
        <Route path="games" element={<GamesList />} />
        <Route path="games/:id" element={<GameDetails />} />
        <Route path="players/:id" element={<PlayerProfile />} />
        {/* Team and name travel as query parameters; see inGamePlayerLogPath. */}
        <Route path="in-game-players" element={<InGamePlayerLog />} />
        <Route path="my-schedule" element={<MySchedule />} />
        <Route path="upload" element={<Upload />} />
        <Route path="account" element={<Account />} />
        <Route path="admin" element={<Admin />} />
        <Route path="updates" element={<Updates />} />
        <Route path="changelog" element={<Changelog />} />
        <Route path="rules" element={<Rules />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}
